// Pending request sub-menu names (checked via pendingRequestSubViewNames)
export const PendingPermissionKeys = [
  "Pending Users",
  "Pending Events",
  "Pending Pitches",
  "Pending Posts",
  "Change Role Request",
  "Pending Chatroom",
];

// Route & sidebar permission keys — use in routes.js, RouteProtector, Profilesidebar
export const PERMISSION_KEYS = {
  // Sidebar-only (no route guard)
  DASHBOARD: "dashboard",
  PENDING_REQUEST_MODULE: "pendingRequestModulePermission",
  // Pending requests (sub-menu names)
  PENDING_USERS: "Pending Users",
  PENDING_EVENTS: "Pending Events",
  PENDING_PITCHES: "Pending Pitches",
  PENDING_POSTS: "Pending Posts",
  CHANGE_ROLE_REQUEST: "Change Role Request",
  PENDING_CHATROOM: "Pending Chatroom",
  // Module permissions (reducer keys: permission[key]?.isView)
  USER_PERMISSION: "userPermission",
  POST_PERMISSION: "postPermission",
  EVENT_PERMISSION: "eventPermission",
  PITCH_PERMISSION: "pitchPermission",
  CHATROOM_PERMISSION: "chatRoomPermission",
  SUB_ADMIN_PERMISSION: "subAdminPermission",
  NOTIFICATION_PERMISSION: "notificationPermission",
  DATA_ANALYTICS_PERMISSION: "dataAnalyticsPermission",
  CUSTOMER_SUPPORT_PERMISSION: "customerSupportPermission",
  CUSTOMER_FEEDBACK_PERMISSION: "customerFeedbackPermission",
  APP_INTRO_PERMISSION: "appIntroPermission",
  REPORT_USER_PERMISSION: "reportUserPermission",
  CMS_ADMIN_PERMISSION: "cmsAdminPermission",
  TALENT_PERMISSION: "talentPermission",
  SPECIALITY_PERMISSION: "specialityPermission",
  CATEGORY_PERMISSION: "categoryPermission",
};